module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("December 4th 1814")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T")])]), _vm._v("he inhabitants of Winterbourne St Swithin prided themselves upon their village. It was no mere rural backwater, no sleepy hamlet full of rustics and yeomen whose social hierarchy was topped off by a red-faced squire and whose amenities consisted of the church and a tavern or two.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Theirs, they boasted, was a bustling community straddling the post road to Aylesbury with a glimpse over the meadows to the waters of the new canal ordered by the crazy old Duke of Bridgewater, up in his mansion on the Chiltern crest. There was the Bird in Hand, a large coaching inn, to serve the stage and the mail and the carriages of the gentry going to and from London and Oxford. There was the fine Winterbourne Hall with the Nugents to preside over local society and half a dozen gentry houses in the vicinity to fill the pews of the grey stone church with the living, and the marble monuments with the dead.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And there was even a shop, a superior emporium selling haberdashery and lengths of cloth, the London and Oxford papers a day late and snuff, tea and Hungary water.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The life of the village centred around the church, the Bird in Hand and the Green, the grassy heart of the community with its duck pond, decaying stocks, venerable oak tree and ring of fine houses and half-timbered cottages.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On a raw, damp Thursday morning three respectable housewives made their way around the Green, deep in discussion of new and fascinating intelligence. It seemed there was no doubt that the gentleman who had taken the Old Manor—the one architectural blot upon the village centre—was none other than an earl.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Or, as it might be, a duke,’ Mrs Thorne hazarded hopefully, lifting her skirts to negotiate a puddle. ‘Whichever, ’tis a fine thing for Winterbourne. He’ll bring down all his society friends, you mark my words, and he’ll be hiring on staff and wanting eggs and milk and bacon.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘If he wanted his society friends, what’s he doing in Winterbourne in December?’ her bosom enemy Widow Clare enquired tartly. ‘The nobs are all off visiting, or at their big country houses. What’s an earl doing hiring that old barn of a place? Outrunning his creditors, that’s what. I tell you, ladies, it’ll be cash on the nail for any eggs that household wants to buy from my hens!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, and nobody’s seen him,’ Mrs Johnson squeaked, her eyes popping at the thought of an earl in the village, even one fallen upon hard times. ‘I’ve seen his butler, mind—I thought it was his lordship himself for a minute, so grand and starched up he was—talking to poor Bill Willett. “I will trouble you, my man,” he said, all frosty-like, “I will trouble you to remember that only the freshest milk and cream is fit for his lordship’s table and that cream is fit only for the cat.” And have you seen the horses?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("The other ladies nodded. Not only had they seen them arrive three days ago but had been bored to death at dinner by their husbands and sons carrying on about the splendour of ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("his lordship’s stable. But, to everyone’s chagrin, it seemed that his lordship had driven himself down from London and had managed to arrive at the one moment of the day when not a single curious eye was focused on the Green, but instead was watching the spectacle of the Mail sweeping through.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He’ll have to come out sooner or later,’ Mrs Thorne prophesied comfortably. ‘Even if the bailiffs are after him.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She broke off as a gig turned off the main road and was driven at a spanking pace around the far side of the Green. It was a modest but somewhat rakish vehicle—the sort that a sporting curate might favour, perhaps—drawn by a neat Welsh cob.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The ladies stared as best they could from the shelter of bonnets and hoods as the gig turned through the gates of the pretty little house that faced the red brick façade of the Old Manor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Well, did you see that?’ the Widow demanded unnecessarily. ‘That was driven by a female!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘With a groom by her side,’ Mrs Thorne added. ‘And she’s gone into the Moon House.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Then the rumours are true,’ Mrs Johnson concluded, quite unashamedly craning her neck now. But the vehicle and its occupants had vanished through the gate posts and the house had resumed its air of empty neglect. ‘Sir Edward "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("did")]), _vm._v(" sell it before he died. But who is she?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fascinated, the three continued on their way to the end of the Green, but the high wall of the Old Manor defeated their avid stares on one side and the dirt-streaked, empty windows of the opposite house stared blankly back at them from the other.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With infinite slowness, another ivy tendril curled out to cover even deeper the carved crescent moon that crowned the front door of the little house, a single star caught in its horns.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("In the muddy yard behind the house, Miss Lattimer accepted the hand her groom held out and hopped neatly ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("down from the gig, quite oblivious to the puddles. Pushing back her veil with a careless hand she stared around her with proprietary interest. ‘Here we are, Jethro. The Moon House!’ It was hard to keep a grin of pure pleasure from her face despite the air of neglect the yard radiated. A home again. Her home and a new start.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The groom, a gangling, solemn-faced youth not much above sixteen, glanced dismissively around and observed, ‘So we are, Miss Hester. And your hair’s coming down at the back again.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, bother.’ Hester put up her hands and made an ineffectual attempt to push the brown curls back into their confining net. ‘Never mind, there’s no one here to observe it. Now, Jethro, you see to stabling Hector and have a look at the rooms over the stable. I understand from the agent they are suitable and should have a bed and other furniture but I am certain they’ll need a good clean before you sleep there, and certainly a fire… What is it?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Hector, Miss Hester?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The cob. I thought I had better give him a name and Hector seems appropriate. It is a good name, do you not think?’ She regarded the animal hopefully: she had never had to buy a horse before, but she felt confident that she had made a good choice two days ago.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The boy’s solemn face grew longer behind its mask of freckles and the occasional pimple. ‘I could not say, Miss Hester.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hester smiled suddenly, a flashing smile that gave her an unexpected air of pure mischief. ‘Now do not practise your butler’s voice out here, Jethro! In the house you can buttle as much as you like—when you are not being boot boy, kitchen hand and footman. Out here you are the groom and the gardener—if it ever stops drizzling. We are all going to have to learn to be many things—I, for example, am about to go inside and become the housekeeper.’")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She reached into the back of the gig and lifted out a small portmanteau, her reticule and an umbrella, adding as she turned away, ‘And cook too, unless a miracle occurs and Miss Prudhome and Susan arrive in time before dinner.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I doubt it, Miss Hester,’ Jethro observed gloomily, beginning to unbuckle the cob’s harness and lead it out of the shafts. ‘I’ll bring the hampers in a minute and get the range going.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hester doubted it too. Her companion suffered so much from motion sickness that the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chaise")]), _vm._v(" could move only at the slowest speed the postilion could be held to; goodness knew when she, Susan and the light luggage would arrive. Hester would doubtless have to see to dinner tonight as well as making up the beds and fires and chasing the worst of the spiders out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But these lowering considerations vanished as she drew the large key from her reticule and set open the back door of the Moon House. Hester stepped slowly over the threshold into a dim, chill room, a little knot of anticipation and excitement in her stomach as she relished the moment. The air was still, redolent of dust, of old ashes and, regrettably, of mice. Then, as she stood there letting her eyes adjust to the shadows, it seemed as though a faint zephyr of a warm breeze filled the space whispering of laughter, roses, happiness—and as suddenly was gone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Hester smiled at her own fancy; it seemed that pure happiness could take tangible form. Oh, yes, this was a happy house—she had known that from just a few minutes’ observation over a year ago. She had stood at the gate, staring entranced at the overgrown rose-filled garden, the ivy-hung façade, the felicitous arrangement of doors and windows, the ineffable, indescribable air of charm that hung over the neglected little house. And then she had hurried back over the Green to the Bird in Hand and to John, her friend and protec")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("tor, who was waiting patiently in the private parlour while she shook the stiffness from her limbs.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He should never have undertaken that journey to Oxford; it marked the sharp deterioration in his condition, which had led to its inevitable end three months ago. They had only been together eighteen months, yet she still ached for his company, for their friendship and intimacy. If he had not protected her, in the face of scandal and family opposition, goodness knows what would have become of her after her father’s death.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hester shook herself briskly. John had known how short a time he had—better to do what he wanted than to purchase a few weeks at the expense of inaction and boredom. That part of her life was over now and she must learn not to brood upon memories and to stand upon her own two feet. She had learned from it and it had left her a legacy in both experience and scandal, as well as just enough money for genteel independence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had never been inside the mysteriously named Moon House, never seen it again after that one brief encounter. All her lengthy negotiations had been undertaken by an agent and she had simply placed her trust in his diligence and her own instinct. Now she pushed the door shut behind her and saw she was in the kitchen. Well, that was just as described— equipped with an old range and pine table, some chairs and dressers, the dulled glint of unpolished copper catching the light from the cobwebbed window. The next job for Jethro would be trying to light the range, if the chimney could be persuaded to draw. Hester smiled wryly: she was beginning to suspect they might have to take themselves over to the Bird in Hand for dinner.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Hester dumped the portmanteau and umbrella unceremoniously on the table, pulled off her bonnet with scant regard for the further chaos it wrought with her hair and tossed her pelisse on the chair. A rummage in the portmanteau produced ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("a shawl, which she tied around her shoulders, a voluminous apron, which she struggled into, and a handful of soft rags ideal for dusting or giving spiders the rightabout.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Setting herself to explore, she emerged through a green baize-covered door into an alcove formed by the gracious upwards sweep of the staircase—somewhat marred now by dangling cobwebs. Hester swiped at them, sneezed, rubbed her nose with the back of her hand, transferring a large smudge on to nose-tip and cheek in the process, and stepped out into the hall.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("yes")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was unaware of speaking aloud, only conscious of the airy proportions, the elegant staircase, the quality of the cold light filtering through the fanlight over the door, despite the curtain of ivy that hung across it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The walls were dingy with dust, marked here and there with ghostly oblongs where pictures or mirrors had once hung. The marble floor, chequered in an unusual grey and white, was grimy—but she could see none of the faults. The feeling of welcome and of belonging swept over her again and Hester walked slowly down the hall, then turned to lean back against the deep-cut panels of the front door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘This is mine,’ she said aloud, her tone wondering, then more strongly, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("‘Mine.’")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The blow on the door behind her was so unexpected, so abrupt, it sounded like thunder. With a shriek Hester leapt away and turned gasping to face it. Effortfully she dragged a breath up from the depths and clasped her trembling hands together while she composed herself. Someone had knocked on the door, that was all. If she had not been mooning like an idiot instead of doing some useful dusting or lighting a fire, it would have sounded perfectly normal.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("The knocker fell again. Hester scrabbled in her pocket ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("where she had transferred the keys and found the largest. This must be for the front door. She turned it, struggled for a moment with the bolts and finally dragged the door open.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Guy Westrope tapped one foot irritably on the step and cursed himself for a sentimental fool. What the devil was he doing here when he could have joined Carew’s party in Rutland? Now he was stuck in a muddy Buckinghamshire village in a hideous house, the target of every prying yokel and gossiping goodwife. He raised an impatient hand to the knocker again, then dropped it as the door began to open.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The dishevelled figure revealed by the part-open door regarded him silently. She was of medium height with an oval face, big brown eyes, a wide and solemn mouth and quantities of ill-controlled brown hair. The dirty smudge across the apparition’s face and the voluminous apron indicated that this particular housemaid had been engaged in dusting, a supposition confirmed when she hastily thrust the hand holding a bundle of rags behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Guy realised he was probably scowling and pulled himself together; his unfamiliar inner turmoil was no excuse for treating subordinates rudely. This particular one appeared to have been cowed into speechlessness by his appearance. For some reason he had an almost irresistible urge to lean forward and rub the smudge off her cheek. He clasped his hands behind his back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Good morning. Is your mistress at home?’ Parrott had reported a woman arriving alone, save for a groom. Presumably he would be dealing with a widow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Something he could have sworn was mischief flashed into the maid’s eyes and was gone. Her voice emerged in a whisper. ‘No, sir. Leastways, she’s not receiving, sir.’ She appeared to pull herself together a little. ‘Would you be wishful of leaving a message, sir?’")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Guy extracted a card and held it out. A remarkably delicate hand, the knuckles smeared with cobwebs, took it. ‘Will your mistress be at home tomorrow?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Er…yes, sir…my lord, I should say.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This was hard work. Was this brown-eyed girl afraid of him or just naturally shy? He tried a smile and saw her eyes widen a little. He entertained the sudden fancy that her thoughts showed in her eyes, but in a language he could not read. ‘And at what time might it be convenient for her to receive me, do you think?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Three o’clock.’ That was unexpectedly decisive, especially as it was not the conventional time of day to receive visitors.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Very well, then. Please tell your mistress that I will do myself the honour of calling upon her at three tomorrow. Good day.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, my lord. Um…good day, my lord.’ There was the merest suggestion of a smile on that solemn mouth. It made the swell of the lower lip seem almost pouting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The door swung shut before he had half-turned on the step. Guy walked slowly back down the overgrown path. A quaint little creature, that maid. Fetching brown eyes and the piquancy of that solemn mouth—it would be interesting to make her smile again. He shook himself briskly and quickened his pace. This would never do—two days in the sticks and he was already eyeing the servant girls. He would take the curricle and the new greys out this afternoon and give himself something to think about other than the Moon House and its present occupants.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the silent hall Hester leaned against the closed door in the same position she had assumed before and regarded the card in her hand while her heartbeat returned to something approaching normal.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Guy Westrope, Earl of Buckland. Monks Grange, Buckland ")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Regis, Wiltshire and an excellent London address. What on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("earth")]), _vm._v(" was an earl doing calling upon her, especially as he presumably had no idea who she was? Hester pulled herself together and ran into the room to her right to peer through the window. She could just see the top of his tall hat passing the wall of that hideous house opposite.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What was an earl, who one might well expect to be wintering at his own or his acquaintances’ country estates, doing calling upon an unknown lady in a Buckinghamshire village? With the memory of those very blue eyes vivid in her mind, Hester indulged a moment’s fantasy that he had followed her from London, infatuated by her beauty and charm, which he had glimpsed from afar. The thought of being pursued by someone that powerful, that masculine, made her heart race again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a laugh at her own foolishness, Hester rubbed her handful of dust cloths over a cracked mirror hanging by the window and peered into its mottled depths. The vision revealed there cut any thought of laughter quite dead.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What a fright!’ There was a dark smudge right across her nose and one cheek, her hair was coming down, her collar was marked and a hasty glance down at hands and apron confirmed the picture of a slatternly housemaid. ‘Oh, my goodness.’ That would teach her to entertain fantasies about strange men.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She gazed around what had obviously once been a delightful reception room in horror. Her suggestion that the earl might call at three the next day had assumed that it would be simple to produce a civilised room to receive him in by then, and that he might be no more than mildly surprised by the eccentricity of a lady who did her own dusting and pretended to be her own housemaid.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Now she could see they would have to labour all day to make this room and the hall decent—and what he would think ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("of such an abandoned creature as she must have appeared did not bear thinking about.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What does that matter?’ Hester asked herself briskly, marching across the hall to see if the opposite room was any better. It was not. ‘He is probably just an acquaintance of John’s.’ That was not much comfort. If that was so he must already regard Miss Lattimer as an abandoned hussy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I must stop talking to myself,’ she chided, promptly ignoring her own advice as she made her way back to the stairs. ‘Bedrooms next.’ It would be as well to find out the worst about those before the day was much older. The agent’s description of the house as ‘partly furnished’ was proving somewhat over-optimistic.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And what do you care what some earl thinks about you, Hester Lattimer?’ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Not much in general")]), _vm._v(", her inner self answered, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("but that particular man…")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The first bedroom yielded a decent-enough-looking bedstead with dust sheets over the mattress, which appeared dry and mercifully free of mice. Hester peeped into three other rooms, each with bedstead and mattress, thank goodness, and then opened wide the door into the room overlooking the front garden.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh! How lovely.’ This room had two generous windows, each with a window seat. Silk draperies marred with dust hung at each casement and between them stood a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chaise-longue")]), _vm._v(" with a little table beside it. The bed was a charmingly feminine confection with slim posts festooned with embroidered silk. Hester touched one fall carefully, hastily withdrawing her hand as some of the silk shattered where it had been folded for so long. Again, enough care had been taken to protect the mattress and the room appeared habitable, if dirty and bone cold.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("This chamber would be hers and Prudy and Susan could ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("have their choice of the other rooms. Doubtless there were servants’ rooms in the attic, but they had too much to do to contemplate putting those to rights for quite a while. Susan would be much more comfortable down here.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was another door in the corner of the room. Hester crossed to it, pausing for a moment to look at the ugly house opposite. In the summer it would be screened for the most part by a spreading elm tree; now it showed gaunt through the bare branches. Several windows were visible on the first floor, but there were no signs of life. Who lived there? Would they make congenial neighbours? She flicked over the catch on the window and after a tussle managed to push up the lower sash. Sharp, clear air flowed into the musty room and she smiled, taking a moment to enjoy it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was the sound of voices opposite and a gate in the high wall to the rear of the house opened. A curricle drawn by a pair of dark greys turned sharply out and headed away from the Green and out of the village. Unmistakably it was the earl who was driving and her own front wall was low enough for Hester to have an uninterrupted view of Guy Westrope’s profile.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hester realised that she had been far too flustered to have more than a muddled impression of him from their encounter. Blue eyes, those she did recall, although at this distance they could not be discerned. She could not say what colour his hair was, but she remembered those eyes and the size of him—tall, broad-shouldered and powerful. To that she could now add the impression of a determined chin. He did not look like a man to be trifled with and the scowl with which he had greeted her, and the coolly polite tones he had used to address her, left her more than a little apprehensive over how he might react to discovering the deception she had practised on him. But when he had smiled, there was the glimpse of quite another man.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At least she now knew who her neighbour was, although congenial was hardly the word she would use to describe him. And it only added to the mystery: to find he was staying at the Bird in Hand while he conducted whatever business he had with her was one thing—but why was he staying here?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If she didn’t stop idling about and get on with making this house fit to receive visitors, she’d lower herself even further in his estimation, she scolded herself mentally, getting to her feet and pushing open the remaining door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It opened into a dressing room and on to a scene of violence. Hester halted, appalled, on the threshold. The shield-shaped mirror that had stood on the dressing table was face down upon the floor, its glass smashed into shards that still lay where they had fallen. The doors to the clothes-presses hung open with the empty shelves pulled out and the chair before the dressing table was thrown on its side. One curtain hung from its last two rings, seemingly dragged down by some clutching hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A mass of filmy cloth lay at her feet. Automatically Hester stooped and picked it up, shaking it out to reveal an outrageously pretty nightgown of Indian muslin. It had been ripped from neck to hem. She moved abruptly backwards and something skittered out from beneath her foot. Under the blanketing dust the floor was strewn with pearls, enough to have made a veritable rope when strung.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What had happened in this chamber? Abduction? Rape? Murder? The calmly happy atmosphere of the house seemed to freeze here into anger and fear. Behind her the curtains flapped as the outer door opened and the door at her back slammed shut with enough force to propel her into the desecrated room.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("Hester swung round, suddenly afraid, her feet scrabbling ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("on the treacherous pearls, her grasp on the door handle hampered by the nightgown. Against her own hands it began to turn. Someone was outside.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  })]), _c('a', {
    attrs: {
      "id": "page20"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page20"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65aecd73","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459225107_ch01.vue
// module id = 72
// module chunks = 0